function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.582 9.875C14.7279 9.875 14.8008 9.94792 14.8008 10.0938V10.5312C14.8008 10.6771 14.7279 10.75 14.582 10.75H1.23828C1.11068 10.75 1.0013 10.7135 0.910156 10.6406C0.83724 10.5495 0.800781 10.4401 0.800781 10.3125V0.46875C0.800781 0.322917 0.873698 0.25 1.01953 0.25H1.45703C1.60286 0.25 1.67578 0.322917 1.67578 0.46875V9.875H14.582ZM3.48047 5.69141L5.77734 3.42188C5.99609 3.20312 6.20573 3.20312 6.40625 3.42188L8.73047 5.71875L10.9727 3.47656L9.74219 2.24609C9.54167 2.04557 9.49609 1.80859 9.60547 1.53516C9.71484 1.26172 9.91536 1.125 10.207 1.125H13.4883C13.6159 1.125 13.7161 1.17057 13.7891 1.26172C13.8802 1.33464 13.9258 1.4349 13.9258 1.5625V4.84375C13.9258 5.02604 13.8529 5.18099 13.707 5.30859C13.5794 5.4362 13.4245 5.5 13.2422 5.5C13.0781 5.5 12.9323 5.4362 12.8047 5.30859L11.5742 4.10547L9.03125 6.64844C8.83073 6.86719 8.62109 6.86719 8.40234 6.64844L6.10547 4.35156L4.10938 6.32031C4 6.41146 3.89974 6.41146 3.80859 6.32031L3.48047 5.99219C3.38932 5.90104 3.38932 5.80078 3.48047 5.69141ZM10.7266 2L13.0508 4.32422V2H10.7266Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.b79b8742e44e4c295c6c73b0e6fad7ab.svg";
export { ForwardRef as ReactComponent };